import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { getToken, isSSR } from "@cinch-labs/shared-util";
import { Env, readFromEnv } from "@cinch-nx/environments";
import { datadogRum } from "@datadog/browser-rum";
import axios from "axios";
import { create } from "zustand";
var userStoreConfig = {
    authKey: "",
    legacyAuthKey: "",
    profileServiceUrl: "",
    identityServiceUrl: "",
    redirectUrlKey: ""
};
var httpClient;
var onSessionExpiredCallback;
export var initUserStore = function(config) {
    var axiosImpl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : axios;
    userStoreConfig = _object_spread({
        identityServiceUrl: readFromEnv(Env.IdentityServiceUrl),
        profileServiceUrl: readFromEnv(Env.ProfileServiceUrl),
        redirectUrlKey: readFromEnv(Env.RedirectUrlKey),
        authKey: readFromEnv(Env.AuthKey),
        legacyAuthKey: readFromEnv(Env.LegacyAuthKey)
    }, config);
    var _httpClient = axiosImpl.create();
    _httpClient.interceptors.request.use(function(request) {
        var token = getToken({
            authKey: userStoreConfig.authKey,
            legacyAuthKey: userStoreConfig.legacyAuthKey
        });
        request.headers = _object_spread_props(_object_spread({}, request.headers), {
            Authorization: "Bearer ".concat(token === null || token === void 0 ? void 0 : token.access_token)
        });
        return request;
    });
    _httpClient.interceptors.response.use(undefined, function(error) {
        var ref, ref1;
        if ((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 401 || (error === null || error === void 0 ? void 0 : (ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 403) {
            onSessionExpiredCallback === null || onSessionExpiredCallback === void 0 ? void 0 : onSessionExpiredCallback();
        }
        return Promise.reject(error);
    });
    httpClient = _httpClient;
};
export var UserPreference;
(function(UserPreference) {
    UserPreference["UNKNOWN"] = "UNKNOWN";
    UserPreference["YES"] = "YES";
    UserPreference["NO"] = "NO";
})(UserPreference || (UserPreference = {}));
export var useUserStore = create(function(set, get) {
    onSessionExpiredCallback = function() {
        set({
            status: "expired"
        });
    };
    return {
        status: "unknown",
        setStatus: function(status) {
            return set({
                status: status
            });
        },
        fetchUser: /*#__PURE__*/ _async_to_generator(function() {
            var authKey, legacyAuthKey, profileServiceUrl, token, profile, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authKey = userStoreConfig.authKey, legacyAuthKey = userStoreConfig.legacyAuthKey, profileServiceUrl = userStoreConfig.profileServiceUrl;
                        if (isSSR()) {
                            return [
                                2
                            ];
                        }
                        token = getToken({
                            authKey: authKey,
                            legacyAuthKey: legacyAuthKey
                        });
                        if (!token) {
                            return [
                                2,
                                set(function() {
                                    return {
                                        status: "invalid"
                                    };
                                })
                            ];
                        }
                        set(function() {
                            return {
                                status: "pending",
                                token: token
                            };
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            httpClient.get("".concat(profileServiceUrl, "/userprofile"))
                        ];
                    case 2:
                        profile = _state.sent().data;
                        return [
                            2,
                            set(function() {
                                return {
                                    status: "valid",
                                    profile: profile,
                                    token: token
                                };
                            })
                        ];
                    case 3:
                        e = _state.sent();
                        datadogRum.addError(new Error("FetchUserProfileActionFailed"));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }),
        updatePassword: function() {
            var _ref = _async_to_generator(function(oldPassword, newPassword) {
                var identityServiceUrl, e;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            identityServiceUrl = userStoreConfig.identityServiceUrl;
                            set(function() {
                                return {
                                    status: "updating"
                                };
                            });
                            return [
                                4,
                                httpClient.put("".concat(identityServiceUrl, "/password"), {
                                    oldPassword: oldPassword,
                                    newPassword: newPassword
                                })
                            ];
                        case 1:
                            _state.sent();
                            set(function() {
                                return {
                                    status: "valid"
                                };
                            });
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            datadogRum.addError(new Error("UpdatePasswordActionFailed"));
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(oldPassword, newPassword) {
                return _ref.apply(this, arguments);
            };
        }(),
        updateProfile: function() {
            var _ref = _async_to_generator(function(updatedFields) {
                var profileServiceUrl, fullProfile, updatedProfile, e;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            profileServiceUrl = userStoreConfig.profileServiceUrl;
                            set(function() {
                                return {
                                    status: "updating"
                                };
                            });
                            fullProfile = _object_spread({}, get().profile, updatedFields);
                            updatedProfile = _object_spread({}, updatedFields);
                            return [
                                4,
                                httpClient.put("".concat(profileServiceUrl, "/userprofile"), updatedProfile)
                            ];
                        case 1:
                            _state.sent();
                            set(function() {
                                return {
                                    profile: fullProfile,
                                    status: "valid"
                                };
                            });
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            datadogRum.addError(new Error("UpdateProfileActionFailed"));
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(updatedFields) {
                return _ref.apply(this, arguments);
            };
        }(),
        logout: function() {
            var redirectUrlKey = userStoreConfig.redirectUrlKey;
            localStorage.removeItem(redirectUrlKey);
            window.location.assign("/logout");
        },
        login: function() {
            window.location.assign("/login");
        },
        register: function() {
            window.location.assign("/login");
        }
    };
});
